import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { ProfileProvider } from "./contexts/ProfileContext";
import { NurseDataProvider } from "./contexts/NurseDataContext";
import { BeneficiariesProvider } from "./contexts/BeneficiariesContext";
import { CenterProvider } from "./contexts/CenterContext";
import { SidoSiggProvider } from "./contexts/SidoSiggContext";

// 여러 Provider를 하나로 합치는 함수
const combineProviders = (providers) => providers.reduce(
    (AccumulatedProviders, CurrentProvider) =>
        ({ children }) =>
            (
                <AccumulatedProviders>
                    <CurrentProvider>{children}</CurrentProvider>
                </AccumulatedProviders>
            ),
    ({ children }) => <>{children}</>
);

const AppProviders = combineProviders([
    AuthProvider, 
    ProfileProvider, 
    NurseDataProvider, 
    BeneficiariesProvider,
    CenterProvider,
    SidoSiggProvider,
]);

export default AppProviders;